




























import Vue from 'vue';
import Component from 'vue-class-component';
import { Action } from 'vuex-class';

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import authenticationAPI from '@/api/authentication';
import usersAPI, { PayloadChangeEmailRequest } from '@/api/users';

/**
 * Types
 */
const initialForm = {
	newEmail: '',
};

/**
 * Composant de fenêtre modale de changement d'email.
 */
@Component({ mixins: [mixinsAPI] })
export default class ChangeEmailDialog extends Vue {
	$refs!: {
		modal: Dialog
	};

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	form = new PayloadChangeEmailRequest();
	callbackOnEmailChanged: any;
	isLoading = false;

	/** Méthodes */
	async open(currentEmail: string, callbackOnEmailChanged: any) {
		this.form = Object.assign({}, initialForm);
		this.form.newEmail = currentEmail;
		this.callbackOnEmailChanged = callbackOnEmailChanged;
		this.$refs.modal.open();
	}

	close() {
		this.$refs.modal.close();
	}

	async handleSubmit() {
		this.isLoading = true;
		try {
			await usersAPI.changeEmail(this.form);
			this.callbackOnEmailChanged();
			this.openInfo(this.$t('snackbar.success'));
			this.isLoading = false;
			this.close();
		}
		catch (err) {
			(this as any).handleAPIError(err);
			this.isLoading = false;
		}

	}
}
